import { BaseComponentService } from 'src/app/services/_app/base-component.service';
import { DisciplineRecordService } from 'src/app/services/discipline-record.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import DisciplineRecord from 'src/app/models/discipline-record.model';
import { ApiError } from 'src/app/models/api/api-error.model';
import { Component, inject, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-user-discipline-record-dialog',
  templateUrl: './user-discipline-record-dialog.component.html',
})
export class UserDisciplineRecordDialogComponent {
  private baseComponentService = inject(BaseComponentService);
  private disciplineRecordService: DisciplineRecordService = inject(
    DisciplineRecordService
  );

  protected form: FormGroup = new FormGroup({
    authorId: new FormControl<string | undefined>(undefined),
    userId: new FormControl<string | undefined>(undefined),
    text: new FormControl<string | undefined>(undefined),
    date: new FormControl<string>(
      new Date().toISOString()?.split('T')?.at(0) ?? ''
    ),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { userId?: string | undefined },
    public dialogRef: MatDialogRef<UserDisciplineRecordDialogComponent>
  ) {
    this.form.patchValue({ userId: this.data.userId });
  }

  protected onConfirm() {
    let data = { ...this.form.value };
    data.author = data.authorId;
    data.user = data.userId;
    this.disciplineRecordService.postDisciplineRecord(data).subscribe({
      next: (response) => {
        this.dialogRef.close(new DisciplineRecord(response.data));
      },
      error: (error) => {
        console.error('postDisciplineRecord - ERROR:', error);
        this.baseComponentService
          .showErrorDialog({ error: new ApiError(error) })
          .subscribe();
      },
    });
  }

  protected onDismiss() {
    this.dialogRef.close(false);
  }
}
